import InitComponent from 'Modules/InitComponent';
import CounselorImage from './components/CounselorImage.vue';
import store from 'Stores/store';

const counselorImageElements = document.querySelectorAll(
  '.vue-counselor-image'
);

if (counselorImageElements.length > 0) {
  counselorImageElements.forEach((element) => {
    const initCounselorImage = new InitComponent({
      selectors: element,
      components: { CounselorImage },
      template: `<CounselorImage />`,
      store,
    });

    initCounselorImage.init();
  });
}
